module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/3-449fb30e6ebfbc69b8efebdae2910bec.png";